export default __webpack_public_path__ + "static/media/head-zoomed.10021067.svg";